<div class="user-details-container">
  <div class="avatar-container">
    <img *ngIf="avatarUrl; else elseBlock" class="avatar-img" src="{{ avatarUrl }}" alt="avatar" />
    <ng-template #elseBlock>
      <span *ngIf="user" class="user-initials">{{ initials }}</span>
    </ng-template>
    <div></div>
  </div>
  <div class="user-info-container">
    <div class="user-name-info">
      <div class="user-details-name">
        {{ user | transform: getFullName }}
      </div>
      <div class="user-details-email">
        {{ user?.email }}
      </div>
    </div>
    <div class="user-role">
      {{ userRole | translate }}
    </div>
  </div>
</div>
